import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { qprActions } from '../../../../Actions';
import { deliverableService } from '../../../../Services';
import SideNav from './Partials/SideNav';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';

const DeliverableForm = ({ appid }) => {
  const qpr = useSelector((state) => state.qpr_data);
  const dispatch = useDispatch();

  const [deliverable, setDeliverable] = useState({});
  const [validationError, setValidationError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isSubmitButtonActive, setIsSubmitButtonActive] = useState(false);

  const [draft1, setDraft1] = useState(null);
  const [draft2, setDraft2] = useState(null);

  useEffect( () => {
    deliverableService.deliverableShow(appid).then(rslt => {
      setDeliverable(rslt.data?? {});
    });
  }, []);

  useEffect( () => {
    setIsSubmitButtonActive(false);
    if(deliverable && deliverable.information_sheet && deliverable.project_report && deliverable.project_report_pdf && deliverable.presentation && deliverable.blog && deliverable.technical_evaluation_sheet1) {
      setIsSubmitButtonActive(true);
    } 
  }, [deliverable]);
  
  const handleUpload = (e, size=10485760) => {
    setValidationError('');
    const file = e.target.files[0];
    if (file.size > size){
      setValidationError(`File size should not be greater than ${size/1048576}MB!`);
      return;
    }

    switch(e.target.name) {
      case "draft1":
      case "draft2":
      case "information_sheet":
      case "project_report":
      case "blog":
        if(!['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)) {
          setValidationError('Only word(DOCX) files are allowed for blog uploads!');
          return;
        }
        break;
      case "project_report_pdf":
        if(!['application/pdf'].includes(file.type)) {
          setValidationError('Only PDF file is allowed for project report uploads!');
          return;
        }
        break;
      case "presentation":
        if(!['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'].includes(file.type)) {
          setValidationError('Only PPTX files are allowed for presentation uploads!');
          return;
        }
        break;
      default:
        break;
    }

    const formData = new FormData();
    if(deliverable) {
      formData.append("id", deliverable.id);
    }
    
    formData.append([e.target.name], e.target.files[0]);
    
    deliverableService.deliverableSave(formData, appid, true).then(res => {
      setDeliverable(res.data);
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!window.confirm("Are you sure you want to submit? Once submitted, you won't be able to edit the file.")) {
      return;
    }
    setIsSubmitting(true);
    const formData = new FormData();
    e.target && Object.keys(e.target).forEach(key => {
      formData.append(e.target[key].name, e.target[key].value);
    });
    
    deliverableService.deliverableSave(formData, appid).then(res => {
      setDeliverable(res.data);
      setIsSubmitting(false);
    });
  }

  const deleteFile = (id, field) => {
    deliverableService.deliverableDelete(id, field).then(res => {
      setDeliverable(res.data);
    });
  }
  
  const MyModal = () => {
    return (
      <>
      <div className={"fade"} id="myModal" style={{
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1051,
          display: "none",
          width: "100%",
          height: "100%",
          overflow: "hidden",
          outline: 0, 
        }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-scrollable modal-lg">
        <div className="modal-content">
        
          <div className="modal-header">
          {/* <h1 className="modal-title">Modal Heading</h1> */}
          <button type="button" className="close" data-dismiss="modal">×</button>
          </div>
          
          <div className="modal-body">asd
          {selectedFile && 
          <DocViewer
            pluginRenderers={DocViewerRenderers} 
            documents={
            [
              { uri: process.env.REACT_APP_PUBLIC_URL+"/uploads"+selectedFile },
              // { uri: require(selectedFile) }, // Local File
            ]
            } 
          />
          }
          </div>
          
          <div className="modal-footer">
          <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
          </div>
          
        </div>
        </div>
      </div>
      </>
    )
  }
  return (
    <>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className='card border-info' style={{"borderTop": "3px solid"}}>
                <div className='card-header'><h6>Draft 1</h6></div>
                <div className="p-3">
                  <div className="main-form">
                    {deliverable?.draft1? (
                      <div className="row">
                        <div className='col-md-3'>
                          <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.draft1.doc} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                          </a>
                          {!deliverable.draft1.submit_status && (
                          <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "draft1")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                          )}
                        </div>
                        {!deliverable.draft1.submit_status && (
                        <div className='col-md-6 mt-2'>
                          <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                            <input type="hidden" name="id" value={deliverable.id} />
                            <input type="hidden" name="field" value="draft1" />
                            <div className='singel-form'>
                              <button type="submit" className="btn btn-info">
                              {isSubmitting ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Submit</span>}
                              </button>
                            </div>                      
                          </form>
                        </div>
                        )}
                      </div>
                    ) : (
                      <div className='singel-form'>
                        <p>Maximum file size: 25MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='draft1' onChange={(e) => handleUpload(e, 26214400)} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>      
                    )}
                  </div>
                  {deliverable.draft1?.admin?.status == 1 && (
                  <>
                    <hr />
                    <div className='mt-3'>
                      <h6 className='pointer'>Technical Expert's comments:</h6>
                      {deliverable.draft1?.te?.length > 0 ? (
                        <>
                        {deliverable.draft1.te.map(te => {
                          if(te.comment) {
                            return (
                              <p className='mt-2' key={te.name}><b>{te.name}:</b> <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+te.draft1_comments} target="_blank" title="Draft1 with comments"><span className="fa fa-file"></span></a> {te.comment}</p>
                            )
                          }
                          return null;
                        })}
                        </>
                      ) : (
                        <p>{deliverable.technical_expert_comments || "No comments yet."}</p>
                      )}
                    </div>
                  </>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              {deliverable.draft1?.admin?.status == 1 && (
              <div className='card border-info' style={{"borderTop": "3px solid"}}>
                <div className='card-header'><h6>Draft 2</h6></div>
                <div className="p-3">
                  <div className="main-form">
                    {deliverable?.draft2? (
                      <div className="row">
                        <div className='col-md-3'>
                          <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.draft2.doc} target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                          </a>
                          {!deliverable.draft2.submit_status && (
                          <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "draft2")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                          )}
                        </div>
                        {!deliverable.draft2.submit_status && (
                        <div className='col-md-6 mt-2'>
                          <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                            <input type="hidden" name="id" value={deliverable.id} />
                            <input type="hidden" name="field" value="draft2" />
                            <div className='singel-form'>
                              <button type="submit" className="btn btn-info">
                              {isSubmitting ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Submit</span>}
                              </button>
                            </div>                      
                          </form>
                        </div>
                        )}
                      </div>
                    ) : (
                      <div className='singel-form'>
                        <p>Maximum file size: 25MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='draft2' onChange={(e) => handleUpload(e, 26214400)} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>      
                    )}
                  </div>
                  {deliverable.draft2?.admin?.status == 1 && (
                  <>
                    <hr />
                    <div className='mt-3'>
                      <h6 className='pointer'>Technical Expert's comments:</h6>
                      {deliverable.draft2?.te?.length > 0 ? (
                        <>
                        {deliverable.draft2.te.map(te => {
                          if(te.comment) {
                            return (
                              <p className='mt-2' key={te.name}><b>{te.name}:</b> {te.comment}</p>
                            )
                          }
                          return null;
                        })}
                        </>
                      ) : (
                        <p>{deliverable.technical_expert_comments || "No comments yet."}</p>
                      )}
                    </div>
                  </>
                  )}
                </div>
              </div>
              )}
            </div>
          </div>
          
          {deliverable.draft2?.admin?.status == 1 && (
          <div className='card border-info mt-3 p-3' style={{"borderTop": "3px solid"}}>
            <div className='row'>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label><h6>Information Sheet (Docx)</h6></label>
                  </div>
                  <div className='col-md-6'>
                    {deliverable?.information_sheet? (
                      <div className='col-md-12'>
                        <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.information_sheet} target="_blank" rel="noopener noreferrer">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                        </a>
                        {!deliverable.submit_status && (
                        <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "information_sheet")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                        )}
                      </div>
                    ) : (
                      <div>
                        <p>Maximum file size: 10MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='information_sheet' onChange={handleUpload} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>
                    )}
                  </div> 
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label><h6>Project Report (Docx)</h6></label>
                  </div>
                  <div className='col-md-6'>
                    {deliverable?.project_report? (
                      <div className='col-md-12'>
                        <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.project_report} target="_blank" rel="noopener noreferrer">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                        </a>
                        {!deliverable.submit_status && (
                        <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "project_report")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                        )}
                      </div>
                    ) : (
                      <div>
                        <p>Maximum file size: 25MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='project_report' onChange={(e) => handleUpload(e, 26214400)} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>
                    )}
                  </div> 
                </div>
              </div>
              <div className='col-md-6 mt-3'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label><h6>Project Report (PDF)</h6></label>
                  </div>
                  <div className='col-md-6'>
                    {deliverable?.project_report_pdf? (
                      <div className='col-md-12'>
                        <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.project_report_pdf} target="_blank" rel="noopener noreferrer">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                        </a>
                        {!deliverable.submit_status && (
                        <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "project_report_pdf")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                        )}
                      </div>
                    ) : (
                      <div>
                        <p>Maximum file size: 25MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='project_report_pdf' onChange={(e) => handleUpload(e, 26214400)} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>
                    )}
                  </div> 
                </div>
              </div>
              <div className='col-md-6 mt-3'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label><h6>Presentation (PPTX)</h6></label>
                  </div>
                  <div className='col-md-6'>
                    {deliverable?.presentation? (
                      <div className='col-md-12'>
                        <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.presentation} target="_blank" rel="noopener noreferrer">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                        </a>
                        {!deliverable.submit_status && (
                        <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "presentation")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                        )}
                      </div>
                    ) : (
                      <div>
                        <p>Maximum file size: 25MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='presentation' onChange={(e) => handleUpload(e, 26214400)} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>
                    )}
                  </div> 
                </div>
              </div>
              <div className='col-md-6 mt-3'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label><h6>Blog (Docx)</h6></label>
                  </div>
                  <div className='col-md-6'>
                    {deliverable?.blog? (
                      <div className='col-md-12'>
                        <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.blog} target="_blank" rel="noopener noreferrer">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                        </a>
                        {!deliverable.submit_status && (
                        <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "blog")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                        )}
                      </div>
                    ) : (
                      <div>
                        <p>Maximum file size: 10MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='blog' onChange={handleUpload} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className='col-md-6 mt-3'>
                <div className='row'>
                  <div className='col-md-6'>
                    <label><h6>Technical evaluation sheet for the academic mentor (Docx)</h6></label>
                  </div>
                  <div className='col-md-6'>
                    {deliverable?.technical_evaluation_sheet1? (
                      <div className='col-md-12'>
                        <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.technical_evaluation_sheet1} target="_blank" rel="noopener noreferrer">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                        </a>
                        {!deliverable.submit_status && (
                        <FontAwesomeIcon icon={faTrashAlt} onClick={() => deleteFile(deliverable.id, "technical_evaluation_sheet1")} className='ml-2' style={{height: "10px", cursor: "pointer"}} />
                        )}
                      </div>
                    ) : (
                      <div>
                        <p>Maximum file size: 10MB</p>
                        <input type="file" className='custom-file-input1' id="customFile" name='technical_evaluation_sheet1' onChange={handleUpload} />
                        {/* <label className="custom-file-label" htmlFor="customFile">Choose file</label> */}
                        {validationError && <p style={{color:'red'}}>{validationError}</p>}
                      </div>
                    )}
                  </div> 
                </div>
              </div>
            </div>
            {!deliverable.submit_status && (
              <>
              <hr />
              <div className='offset-md-6 col-md-6'>
                <form onSubmit={handleSubmit} data-toggle="validator" noValidate={true}>
                  <input type="hidden" name="id" value={deliverable.id} />
                  <input type="hidden" name="submit_status" value="1" />
                  <div className='singel-form'>
                    <button type="submit" className="btn btn-info" disabled={!isSubmitButtonActive}>
                    {isSubmitting ? <span><FontAwesomeIcon icon={faSpinner} className="fa-spin" /> Please wait</span> : <span>Submit</span>}
                    </button>
                  </div>                      
                </form>
              </div>
              </>
            )}
          </div>
          )}
          {deliverable.submit_status == 1 && (
          <div className='card border-info mt-3 p-3' style={{"borderTop": "3px solid"}}>
            <div className='row'>
              <div className='col-md-12'>
                <h6 className='mb-3'>Technical Evaluation Sheets By Technical Experts:</h6>
                {deliverable?.technical_evaluation_sheet2?.length > 0 ? (
                  <>
                  {deliverable?.technical_evaluation_sheet2?.map(te => {
                    if(te.doc) {
                      return (
                        <a key={te.name} href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+te.doc} target="_blank" className='mr-5' title="Technical evaluation sheet by technical expert">
                          <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} /> 
                        </a>
                      )
                    }
                    return null;
                  })}
                  </>
                ) : (
                  <p>Pending...</p>
                )}
              </div>
            </div>
          </div>
          )}
          {deliverable?.certificate && (
          <div className='card border-info mt-3 p-3' style={{"borderTop": "3px solid"}}>
            <div className='row'>
              <div className='col-md-6 text-center'>
                <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.certificate} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                </a>
                <h6>Certificate</h6>
              </div>
              <div className='col-md-6 text-center'>
                <a href={process.env.REACT_APP_PUBLIC_URL+"/uploads"+deliverable.closure_approval} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFileAlt} style={{height: "50px", cursor: "pointer"}} />
                </a>
                <h6>Closure Approval</h6>
              </div>
            </div>
          </div>
          )}
        </div>
        <MyModal />
      </section>
    </>
  );
};

export default DeliverableForm;